export default [
  {
    title: 'Amazon Brand Store',
    // Brand Store data is keyed by the Ads profile (Amazon Ads API) and needs no Selling Partner
    // connection, so the group is gated like Amazon Attribution ('amazon-ads'), not like Brand
    // Analytics ('amazon-seller').
    channel: 'amazon-ads',
    icon: { icon: 'ic:outline-storefront' },
    badgeContent: 'Preview',
    badgeClass: 'bg-primary',
    children: [
      {
        title: 'Overview',
        action: 'read',
        subject: 'User',
        to: 'brand-store-overview',
        icon: { icon: 'ic:outline-storefront' },
        isNeedBusinessProfile: true,
      },
      {
        title: 'Traffic',
        action: 'read',
        subject: 'User',
        to: 'brand-store-traffic',
        icon: { icon: 'ic:outline-alt-route' },
        isNeedBusinessProfile: true,
      },
      {
        title: 'Products',
        action: 'read',
        subject: 'User',
        to: 'brand-store-products',
        icon: { icon: 'ic:outline-inventory-2' },
        isNeedBusinessProfile: true,
      },
      {
        title: 'Engagement',
        action: 'read',
        subject: 'User',
        to: 'brand-store-engagement',
        icon: { icon: 'ic:outline-timer' },
        isNeedBusinessProfile: true,
      },
      {
        title: 'Page Content',
        action: 'read',
        subject: 'User',
        to: 'brand-store-page-content',
        icon: { icon: 'ic:outline-article' },
        isNeedBusinessProfile: true,
      },
      {
        title: 'Change History',
        action: 'read',
        subject: 'User',
        to: 'brand-store-changes',
        icon: { icon: 'ic:outline-history' },
        isNeedBusinessProfile: true,
      },
    ],
  },
];
